import { jsx as _jsx } from "react/jsx-runtime";
import { QueryClient, QueryClientProvider } from "react-query";
import { PromotionCodes } from "@jti/ui";
const queryClient = new QueryClient();
const PromotionBlock = ({ successMessage, errorMessage, title, description, providers, }) => {
    return (_jsx(QueryClientProvider, { client: queryClient, children: _jsx(PromotionCodes, { title: title, description: description, successMessage: successMessage, errorMessage: errorMessage, promotions: providers }) }));
};
export default PromotionBlock;
//# sourceMappingURL=PromotionBlock.js.map